import React from 'react';
import SMTeamLogo from '../../../../widgets/components/sm/views/SMTeamLogo';
import styled from 'styled-components';
import moment from 'moment';
import _ from 'lodash';

const Cell = styled.div`
    padding: 15px 10px;
    position: relative;
    color: #222;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .name {
        padding: 0 10px;
        white-space: nowrap;
    }

    .side {
        width: calc(50% - 25px);
        display: flex;
        padding: 0 5px;
        align-items: center;
        justify-content: center;
    }
    .status {
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 5px;
        text-align: center;
    }

    .score {
        width: 50px;
        text-align: center;
        display: inline-block;
        font-size: 20px;
    }
    .rnd {
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 12px;
    }
`;

const CellSmall = Cell.extend`
    width: 280px;
    height: 120px;
    margin: 1px;
    background: ${props => (props.active ? `rgba(0, 0, 0, 0.1)` : `rgba(0, 0, 0, 0.05)`)};
    &:hover {
        background: rgba(0, 0, 0, 0.1);
        cursor: pointer;
    }
`;
const CellBig = Cell.extend`
    .name {
        padding: 0 10px;
        font-size: 36px;
    }
    .side {
        width: calc(50% - 45px);
    }
    .score {
        width: 90px;
        text-align: center;
        display: inline-block;
        font-size: 32px;
    }
`;
export const Match = ({
    startDate,
    homeShortName,
    awayShortName,
    homeId,
    awayId,
    tournamentId,
    score,
    statusType,
    properties,
    onClick,
    active,
}) => (
    <CellSmall onClick={onClick} active={active}>
        {statusType === 'notstarted' && <div className="status">{moment(startDate).format('HH:mm')}</div>}
        {statusType === 'finished' && <div className="status">FT</div>}
        {statusType === 'inprogress' && <div className="status">LIVE</div>}
        <span className="rnd">{!_.isNaN(+properties.round) ? 'R' + properties.round : properties.round}</span>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div className="side" style={{ justifyContent: 'flex-end' }}>
                <span className="name">{homeShortName}</span>
                <SMTeamLogo teamId={homeId} width={40} />
            </div>
            {statusType === 'notstarted' && <div className="score">-:-</div>}
            {statusType !== 'notstarted' && (
                <div className="score">
                    {score.home}:{score.away}
                </div>
            )}

            <div className="side" style={{ justifyContent: 'start' }}>
                <SMTeamLogo teamId={awayId} width={40} />
                <span className="name">{awayShortName}</span>
            </div>
        </div>
        <div className="info" style={{ fontSize: 11, textAlign: 'center' }}>
            {moment(startDate).format('D MMM')}
        </div>
    </CellSmall>
);

export const FakeCell = ({ text, onClick }) => <CellSmall onClick={onClick}>{text}</CellSmall>;

export const EventHeader = ({ event, active, onClick }) => {
    const { startDate, homeName, awayName, homeId, awayId, score, statusType, properties } = event;
    return (
        <CellBig onClick={onClick} active={active}>
            {statusType === 'notstarted' && <div className="status">{moment(startDate).format('HH:mm')}</div>}
            {statusType === 'finished' && <div className="status">FT</div>}
            {statusType === 'inprogress' && <div className="status">LIVE</div>}
            <span className="rnd">{!_.isNaN(+properties.round) ? 'R' + properties.round : properties.round}</span>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div className="side" style={{ justifyContent: 'flex-end' }}>
                    <span className="name">{homeName}</span>
                    <SMTeamLogo teamId={homeId} width={60} />
                </div>
                {statusType === 'notstarted' && <div className="score">-:-</div>}
                {statusType !== 'notstarted' && (
                    <div className="score">
                        {score.home}:{score.away}
                    </div>
                )}

                <div className="side" style={{ justifyContent: 'start' }}>
                    <SMTeamLogo teamId={awayId} width={60} />
                    <span className="name">{awayName}</span>
                </div>
            </div>
            <div className="info" style={{ fontSize: 11, textAlign: 'center' }}>
                {moment(startDate).format('D MMM')}
            </div>
        </CellBig>
    );
};

export default Match;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/EventCell.js
 **/